import authAxios from '../authorization/axios';
import constants from '../constants';

export const getLicenseTransactions = async (id: string) => {
  const main = `${constants.api.getLicenseTransactions}/${id}`;

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};


export const freeLicenseService = async (id: number) => {
  const main = constants.api.freeLicense.replace('{licenseId}', String(id));

  // TODO: typing the response.
  const response = await authAxios.post(main);

  return response;
};

export const getAlgoInfo = async (id: string) => {
  const main = constants.api.getAlgoInfo.replace('{txId}', id.toString());

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const changeMailService = async (id: number, data: any) => {
  const main = constants.api.changeMail.replace('{licenseId}', id.toString());

  // TODO: typing the response.
  const response = await authAxios.post(main, data);

  return response;
};

export const changeLicenseExpirationDateService = async (id: number, data: any) => {
  const main =   constants.api.changeLicenseExpirationDate.replace(
    '{licenseId}',
    String(id)
  );

  // TODO: typing the response.
  const response = await authAxios.put(main, data);

  return response;
};


export const getLicensesReport = async () => {
  const main = constants.api.getLicensesReport;

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};



